import React from 'react';
import { SelectInput } from 'react-admin';

import { TaskService, TaskServiceNames, TaskServicesMobileFlow } from '../../../../entities/TaskService';


export const serviceChoices = [
	{id: TaskService.maintenance, name: TaskServiceNames[TaskService.maintenance]},
	{id: TaskService.cleaning, name: TaskServiceNames[TaskService.cleaning]},
	{id: TaskService.outside, name: TaskServiceNames[TaskService.outside]},
	{id: TaskService.deviation, name: TaskServiceNames[TaskService.deviation]},
	{id: TaskService.customerRelated, name: TaskServiceNames[TaskService.customerRelated]},
	{id: TaskService.storage, name: TaskServiceNames[TaskService.storage]},
	{id: TaskService.routines, name: TaskServiceNames[TaskService.routines]},
	{id: TaskService.other, name: TaskServiceNames[TaskService.other]},
	{id: TaskService.incoming, name: TaskServiceNames[TaskService.incoming]},
	{id: TaskService.outgoing, name: TaskServiceNames[TaskService.outgoing]},
	{id: TaskService.op, name: TaskServiceNames[TaskService.op]},
	{id: TaskService.rebuildPallets, name: TaskServiceNames[TaskService.rebuildPallets]},
];


// Choices without the mobile flow services: they can be set only on task
// creation and are not available for recurring tasks.
export const unlockedServiceChoices = serviceChoices.filter(
	choice => !TaskServicesMobileFlow.includes(choice.id)
);


export const ServiceInput = ({ choices = serviceChoices, ...props }) => {
	return (
		<SelectInput {...props} choices={choices} />
	);
};
